'use strict';

const shape = {
  borderRadius: 4
};

module.exports = shape;
//# sourceMappingURL=shape.cjs.map
